"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ordersFilterData;

var _moment = _interopRequireDefault(require("moment/moment"));

var _actionTypes = require("../constants/actionTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initState = {
  fromDate: (0, _moment["default"])().startOf('year').format('DD.MM.YYYY HH:mm:ss'),
  toDate: (0, _moment["default"])().endOf('day').format('DD.MM.YYYY HH:mm:ss'),
  confirmations: {
    groupTimeBy: 'hourly'
  },
  groupItemBy: 'product'
};

function ordersFilterData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionTypes.SET_ORDER_FILTER_DATA:
      return _objectSpread({}, state, {}, action.data);

    case _actionTypes.RESET_ORDER_FILTER_DATA:
      return _objectSpread({}, initState, {}, action.data, {
        reset: true
      });

    case _actionTypes.SET_ORDER_DATE_TABLE_FILTER:
      return _objectSpread({}, state, _defineProperty({}, action.table, _objectSpread({}, state[action.table], {}, action.filterValues)));

    default:
      delete state['reset'];
      return state;
  }
}